import { BaseSerializer } from "./baseSerializer.ts";
import { EngagementTeam } from "../engagementTeam.model.ts";


export class EngagementTeamSerializer extends BaseSerializer {

    public deserialize( data: any ): any {

        const gp = new EngagementTeam();
        this._copyAttributes(gp, data);

        return gp;

    }

}
